import { Component } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { SessionActionsDialogComponent } from '../session-actions-dialog/session-actions-dialog.component';
import { SupportService } from '../services/support.service';

@Component({
  selector: 'app-session',
  templateUrl: './session.component.html',
  styleUrls: ['./session.component.scss'],
  standalone: false
})
export class SessionComponent {

  constructor(
    private dialog: MatDialog,
    public supportService: SupportService
  ) { }

  searchText = '';
  statusFilter = '';
  dateRange = '';
  limit = 50;
  page: number = 0
  total = 0;
  sessions: any[] = [];
  sessionLoader: boolean = false

  // UPDATED COLUMNS (matches new schema)
  columns = [
    'id',
    'target_user_name',
    'target_user_email',
    // 'admin_name',
    'admin_email',
    'created_at',
    'granted_by_ip',
    'actions',
    'status'
  ];

  ngOnInit(): void {

    this.loadSessions()
  }

  loadSessions() {
    this.sessions = []
    this.sessionLoader = true;

    this.supportService.getSessionsHistory(
      this.page,
      this.limit,
    ).subscribe({
      next: (result: any) => {
        this.sessions =  result.sessions || [];
        this.total = result.total || 0;
      },
      error: (err) => {
        console.error(err);
      },
      complete: () => {
        this.sessionLoader = false;
      }
    });
  }

  onPage(event: PageEvent) {
    this.page = event.pageIndex + 1;
    this.limit = event.pageSize;

    this.loadSessions();
  }

  openActionsPopup(session: any): void {
    this.dialog.open(SessionActionsDialogComponent, {
      width: '95vw',
      maxWidth: '1400px',
      height: '85vh',
      data: session,
      autoFocus: false
    });
  }

  exportCSV() {
    console.log('Export CSV triggered');
  }

  // STATUS DERIVATION (IMPORTANT)
  getStatusLabel(status: number): string {
    return status === 0 ? 'Active' : 'Ended';
  }
}